import { render } from "./UserProfileViewContent.vue?vue&type=template&id=2e9d657b&ts=true"
import script from "./UserProfileViewContent.vue?vue&type=script&lang=ts"
export * from "./UserProfileViewContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__